import React from 'react';

import PropTypes from 'prop-types';

import Tippy from '@tippyjs/react';

import { Flexer, Button } from '@ontruck/orc';
import { injectIntl } from 'react-intl';

const getLabel = (documents, needsToPrint, t) => {
  if (documents && documents.length > 0)
    return needsToPrint ? t.documentsForPrint : t.documentsNotToPrint;
  return t.addDocuments;
};

const Documents = React.memo(({ className, color, openModal, id, additional_documents, intl }) => {
  const handleOpen = () => openModal(id);
  const need_to_be_printed = (additional_documents || []).some((file) => file.need_to_be_printed);
  const t = intl.messages.modules.documents;
  const label = getLabel(additional_documents, need_to_be_printed, t);

  return (
    <Flexer.Parent mRight="S" className={className}>
      <Flexer.Child>
        {additional_documents && additional_documents.length > 0 ? (
          <>
            <Tippy
              interactive
              interactiveBorder={10}
              maxWidth="none"
              placement="bottom"
              theme="light"
              content={
                <div>
                  {(additional_documents || []).map((file) => (
                    <p key={file?.id}>
                      <Button
                        href={file.url}
                        nude
                        text={file.name}
                        skin="dark"
                        link
                        target="_blank"
                      />
                    </p>
                  ))}
                </div>
              }
            >
              <span>
                <Button nude text={label} skin={color === 'white' ? 'light' : 'dark'} />
              </span>
            </Tippy>
          </>
        ) : (
          <Button
            nude
            text={label}
            onClick={additional_documents && additional_documents.length <= 0 && handleOpen}
            skin={color === 'white' ? 'light' : 'dark'}
          />
        )}
      </Flexer.Child>

      {additional_documents && additional_documents.length > 0 && (
        <Flexer.Child>
          <Button
            nude
            icon="edit"
            onClick={handleOpen}
            skin={color === 'white' ? 'light' : 'dark'}
          />
        </Flexer.Child>
      )}
    </Flexer.Parent>
  );
});

Documents.propTypes = {
  item_height: PropTypes.number.isRequired,
  intl: PropTypes.object.isRequired,
  showIcon: PropTypes.bool,
};

Documents.defaultProps = {
  showIcon: true,
};

export default injectIntl(Documents);
